import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  loading: false,
  token: null,
  error: false,
  profile_photo_path: null,
  originalAdminUser: null
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = false; 
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.currentUser = action.payload;
      state.token = action.payload.token;
      state.error = false;
    },
    loginFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    logout: (state) => {
      state.currentUser = null;
      state.token = null;
      state.loading = false;
      state.error = false;
      state.originalAdminUser = null;
    },
    updateAvatar: (state, action) => {
      state.currentUser.profile_photo_path = action.payload;
    },
    setOriginalAdminUser: (state, action) => {
      state.originalAdminUser = action.payload;
    },
    clearOriginalAdminUser: (state) => {
      state.originalAdminUser = null;
    }
  },
});

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout, 
  updateAvatar,
  setOriginalAdminUser,
  clearOriginalAdminUser 
} = userSlice.actions;

export default userSlice.reducer;
